// extracted by mini-css-extract-plugin
module.exports = {"breakpointPostContentAreaMin":"746px","breakpointPostContentAreaSmall":"900px","button":"_3Bdxz","flexContainer":"_3BTGY","count":"_8J1xw","switchCounterAndButton":"TECj6"};